// src/utils/speak.js
// Message vocal de bienvenue après connexion (Web Speech API).
const WELCOME_TEXT =
  "Amen Distribution et M G, le leader des pièces automobiles en Tunisie";

function getSynth() {
  return typeof window !== "undefined" ? window.speechSynthesis : null;
}

/**
 * "Amorce" la synthèse DANS le geste utilisateur (clic de connexion).
 * Débloque l'autorisation audio pour que speakWelcome() fonctionne
 * même s'il est appelé plus tard, après l'appel réseau du login.
 */
export function primeSpeech() {
  try {
    const synth = getSynth();
    if (!synth || typeof SpeechSynthesisUtterance === "undefined") return;
    synth.resume();
    const u = new SpeechSynthesisUtterance(" "); // quasi-silencieux
    u.volume = 0;
    synth.speak(u);
    // charge la liste des voix au passage
    synth.getVoices();
  } catch {}
}

function pickFrenchVoice(synth) {
  const voices = synth.getVoices() || [];
  return (
    voices.find((v) => /fr[-_]?FR/i.test(v.lang)) ||
    voices.find((v) => (v.lang || "").toLowerCase().startsWith("fr")) ||
    voices.find((v) => /fran[cç]/i.test(v.name)) ||
    null
  );
}

export function speakWelcome(text = WELCOME_TEXT) {
  const synth = getSynth();
  if (!synth || typeof SpeechSynthesisUtterance === "undefined") return;

  const speakNow = () => {
    try {
      const u = new SpeechSynthesisUtterance(text);
      u.lang = "fr-FR";
      u.rate = 0.98;
      u.pitch = 1;
      u.volume = 1;
      const fr = pickFrenchVoice(synth);
      if (fr) u.voice = fr;
      // Chrome : la synthèse peut rester en pause → resume avant de parler.
      // (⚠️ ne PAS faire cancel() juste avant speak() : bug qui bloque la voix.)
      try { synth.resume(); } catch {}
      synth.speak(u);
    } catch {}
  };

  // Délai léger : laisse la navigation post-login se poser avant de parler.
  const ready = (synth.getVoices() || []).length > 0;
  if (ready) {
    setTimeout(speakNow, 150);
  } else {
    let done = false;
    const run = () => { if (done) return; done = true; setTimeout(speakNow, 60); };
    try { synth.addEventListener("voiceschanged", run, { once: true }); }
    catch { synth.onvoiceschanged = run; }
    setTimeout(run, 500); // filet de sécurité si l'événement ne se déclenche pas
  }
}
